import { render, staticRenderFns } from "./fangdai.vue?vue&type=template&id=ebc0de48&"
import script from "./fangdai.vue?vue&type=script&lang=js&"
export * from "./fangdai.vue?vue&type=script&lang=js&"
import style0 from "./fangdai.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports